import React from "react";
import { Text } from "@radix-ui/themes";
import { useBrand } from "@/shared/brand/useBrand";

export type Crumb = {
  label: string;
  href?: string;
};

export default function Breadcrumb({ crumbs }: { crumbs: Crumb[] }) {
  // Breadcrumbs climb through tracks and clubs, which a branded site leaves out.
  const brand = useBrand();
  if (crumbs.length === 0 || brand) return null;

  return (
    <nav aria-label="Breadcrumb">
      <Text size="2" color="gray" as="p">
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <React.Fragment key={`${i}-${c.label}`}>
              {c.href && !isLast ? (
                <a href={c.href} className="text-accent9 hover:underline">
                  {c.label}
                </a>
              ) : (
                <span aria-current={isLast ? "page" : undefined}>{c.label}</span>
              )}
              {!isLast && (
                <span className="mx-2" aria-hidden="true">
                  ›
                </span>
              )}
            </React.Fragment>
          );
        })}
      </Text>
    </nav>
  );
}
